"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.array.find");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.string.pad-start");
var _shareConfig = require("@/api/decorate/shareConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "ShareList",
  filters: {
    formatDate: function formatDate(value) {
      if (!value) return '';
      // 如果是时间戳格式
      if (typeof value === 'number') {
        var date = new Date(value);
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        var hours = String(date.getHours()).padStart(2, '0');
        var minutes = String(date.getMinutes()).padStart(2, '0');
        var seconds = String(date.getSeconds()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
      }
      // 如果是字符串格式
      if (typeof value === 'string') {
        var _date = new Date(value);
        if (isNaN(_date.getTime())) return value; // 无效日期返回原值
        var _year = _date.getFullYear();
        var _month = String(_date.getMonth() + 1).padStart(2, '0');
        var _day = String(_date.getDate()).padStart(2, '0');
        var _hours = String(_date.getHours()).padStart(2, '0');
        var _minutes = String(_date.getMinutes()).padStart(2, '0');
        var _seconds = String(_date.getSeconds()).padStart(2, '0');
        return "".concat(_year, "-").concat(_month, "-").concat(_day, " ").concat(_hours, ":").concat(_minutes, ":").concat(_seconds);
      }
      return value;
    }
  },
  data: function data() {
    return {
      loading: false,
      searchForm: {
        name: ""
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      // 图片前缀
      imagePrefix: '',
      // 页面列表
      pageList: [],
      // 抽屉相关数据
      drawerVisible: false,
      drawerTitle: "",
      submitLoading: false,
      isEdit: false,
      isView: false,
      // 查看模式
      editId: null,
      formData: {
        title: "",
        image: "",
        page: ""
      },
      formRules: {
        title: [{
          required: true,
          message: "请输入分享标题",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        image: [{
          required: true,
          message: "请上传预览图",
          trigger: "change"
        }],
        page: [{
          required: true,
          message: "请选择分享页面",
          trigger: "change"
        }]
      },
      // 照片墙相关数据
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false
    };
  },
  mounted: function mounted() {
    this.getTableData();
    this.getImagePrefix();
    this.getPageList();
  },
  methods: {
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _shareConfig.getImagePrefix)();
            case 1:
              response = _context.sent;
              this.imagePrefix = response.data || '';
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error("获取图片前缀失败:", _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _shareConfig.queryPageList)();
            case 1:
              response = _context2.sent;
              this.pageList = response.data || [];
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error("获取页面列表失败:", _t2);
              this.pageList = [];
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 根据URL获取页面名称
    getPageNameByUrl: function getPageNameByUrl(url) {
      if (!url) return '';
      var page = this.pageList.find(function (item) {
        return item.pageUrl === url;
      });
      return page ? page.pageName + '(' + page.appid + ')' : url;
    },
    // 获取完整图片URL
    getImageUrl: function getImageUrl(imagePath) {
      if (!imagePath) return '';
      // 如果已经是完整URL，直接返回
      if (imagePath.startsWith('http')) {
        return imagePath;
      }
      // 否则拼接前缀
      return this.imagePrefix + imagePath;
    },
    // 获取表格数据
    getTableData: function () {
      var _getTableData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.loading = true;
              _context3.prev = 1;
              params = {
                page: this.pagination.current,
                limit: this.pagination.size,
                title: this.searchForm.name
              };
              _context3.next = 2;
              return (0, _shareConfig.getPageShareConfig)(params);
            case 2:
              response = _context3.sent;
              // 根据实际返回的数据结构处理
              if (response) {
                this.tableData = response.records || [];
                this.pagination.total = response.total || 0;
              } else {
                this.tableData = [];
                this.pagination.total = 0;
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              console.error("获取数据失败:", _t3);
              this.$message.error("获取数据失败: " + (_t3.message || "未知错误"));
              this.tableData = [];
              this.pagination.total = 0;
            case 4:
              _context3.prev = 4;
              this.loading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function getTableData() {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }(),
    // 搜索
    handleSearch: function handleSearch() {
      this.pagination.current = 1;
      this.getTableData();
    },
    // 新建分享
    handleCreate: function handleCreate() {
      this.isEdit = false;
      this.isView = false;
      this.editId = null;
      this.drawerTitle = "新建分享";
      this.resetForm();
      this.drawerVisible = true;
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.isEdit = true;
      this.isView = false;
      this.editId = row.id;
      this.drawerTitle = "编辑分享";

      // 调用详情接口获取数据
      this.getShareConfigDetail(row.id);
    },
    // 获取分享配置详情
    getShareConfigDetail: function () {
      var _getShareConfigDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        var response, detailData, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.submitLoading = true;
              _context4.prev = 1;
              _context4.next = 2;
              return (0, _shareConfig.getShareConfigDetail)(id);
            case 2:
              response = _context4.sent;
              // 假设返回的数据结构与列表中的记录结构一致
              detailData = response.data || response;
              this.formData = {
                id: detailData.id,
                title: detailData.title,
                image: detailData.image,
                page: detailData.page
              };
              // 初始化文件列表
              this.fileList = this.formData.image ? [{
                name: "预览图",
                url: this.getImageUrl(this.formData.image)
              }] : [];
              this.drawerVisible = true;
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              this.$message.error("获取详情失败: " + (_t4.message || "未知错误"));
            case 4:
              _context4.prev = 4;
              this.submitLoading = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function getShareConfigDetail(_x) {
        return _getShareConfigDetail2.apply(this, arguments);
      }
      return getShareConfigDetail;
    }(),
    // 删除
    handleDelete: function handleDelete(row) {
      var _this = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u5206\u4EAB\"".concat(row.title, "\"\u5417\uFF1F"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        // 调用删除接口
        (0, _shareConfig.deleteShareConfig)(row.id).then(function (response) {
          _this.$message.success("删除成功");
          _this.getTableData();
        }).catch(function (error) {
          _this.$message.error("删除失败: " + (error.message || "未知错误"));
        });
      }).catch(function () {
        _this.$message.info("已取消删除");
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.size = val;
      this.pagination.current = 1;
      this.getTableData();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.current = val;
      this.getTableData();
    },
    // 抽屉相关方法
    // 重置表单
    resetForm: function resetForm() {
      var _this2 = this;
      this.formData = {
        title: "",
        image: "",
        page: ""
      };
      this.fileList = [];
      this.$nextTick(function () {
        if (_this2.$refs.drawerForm) {
          _this2.$refs.drawerForm.clearValidate();
        }
      });
    },
    // 关闭抽屉
    handleDrawerClose: function handleDrawerClose() {
      this.drawerVisible = false;
      this.resetForm();
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.drawerForm.validate(function (valid) {
        if (valid) {
          _this3.submitLoading = true;
          var requestPromise;

          // 根据是编辑还是新增调用不同的接口
          if (_this3.isEdit) {
            // 编辑时调用修改接口
            requestPromise = (0, _shareConfig.updateShareConfig)(_this3.formData);
          } else {
            // 新增时调用保存接口
            requestPromise = (0, _shareConfig.saveShareConfig)(_this3.formData);
          }

          // 调用接口
          requestPromise.then(function (response) {
            _this3.$message.success(_this3.isEdit ? "编辑成功" : "新增成功");
            _this3.submitLoading = false;
            _this3.drawerVisible = false;
            _this3.resetForm();
            _this3.getTableData();
          }).catch(function (error) {
            _this3.$message.error((_this3.isEdit ? "编辑失败: " : "新增失败: ") + (error.message || "未知错误"));
            _this3.submitLoading = false;
          });
        } else {
          _this3.$message.error("请完善表单信息");
          return false;
        }
      });
    },
    // 照片墙相关方法
    // 图片上传前校验
    beforeImageUpload: function beforeImageUpload(file) {
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 处理图片上传
    handleUploadImage: function () {
      var _handleUploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(option) {
        var file, response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              file = option.file;
              _context5.prev = 1;
              // 显示上传loading状态
              this.uploadLoading = true;

              // 调用上传接口
              _context5.next = 2;
              return (0, _shareConfig.uploadPopupImage)(file);
            case 2:
              response = _context5.sent;
              // 处理上传结果
              if (response.code === 200) {
                this.formData.image = response.data;
                // 更新文件列表
                this.fileList = [{
                  name: file.name,
                  url: this.getImageUrl(response.data)
                }];
                this.$refs.drawerForm.validateField("image");
                this.$message.success("图片上传成功");
              } else {
                this.$message.error(response.message || "图片上传失败");
              }
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t5 = _context5["catch"](1);
              this.$message.error("图片上传失败: " + (_t5.message || "未知错误"));
            case 4:
              _context5.prev = 4;
              this.uploadLoading = false;
              return _context5.finish(4);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function handleUploadImage(_x2) {
        return _handleUploadImage.apply(this, arguments);
      }
      return handleUploadImage;
    }(),
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      this.formData.image = "";
      this.fileList = [];
    },
    // 预览图片
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 超出限制
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("只能上传一张图片，请先删除当前图片后再上传");
    }
  }
};